"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNoticeMeetingDescription = exports.getFileIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = require("../..");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const getNoticeMeetingDescription = (eventStart, eventEnd) => {
  return `${(0, _.getFormattedDateTimePretty)(eventStart)} - ${(0, _.getFormattedDateTimePretty)(eventEnd)}`;
};
exports.getNoticeMeetingDescription = getNoticeMeetingDescription;
const getFileIcon = type => {
  switch (type) {
    case 'cal':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_.IconCalendar, {
        primary: true
      });
    case 'application/pdf':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_.IconFilePDF, {
        primary: true
      });
    case 'application/docx':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_.IconFileWord, {
        primary: true
      });
    case 'default':
    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_.IconFile, {
        primary: true
      });
  }
};
exports.getFileIcon = getFileIcon;